import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import useCoverageOptionsLogic from "./useCoverageOptionsLogic";

const columns = [{ field: "name", label: "Name", allowSorting: true }];

const CoverageOptionsPage = () => {
  const { addRoles, deleteRoles, editRoles, initFields, apiRoute } =
    useCoverageOptionsLogic();
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta
          name="description"
          content="Welcome to the Coverage Options Page."
        />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="coverage_option"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default CoverageOptionsPage;
